<template>
  <!-- 协会详情 -->
  <div class="companyInfoWrap">
      <v-downTip :popShow="popShow" ></v-downTip>
      <v-shareHeader :content="shareSwiper"></v-shareHeader>
      <v-shareFooter :content="shareSwiper"></v-shareFooter>
      <div class="wrapDiv">     
        <!-- 头部图片 -->
        <div class="top">        
          <div class="img"><img src="../images/companybg.png" alt=""></div>
        </div>
        <div class="data">
          <div class="name clearfix">
            <div class="img"><img :src="guildInfo.guildLogo" alt=""></div>
            <div class="d1">
              <p class="p1">{{guildInfo.guildName}}</p>
            </div>          
          </div>
        </div>
        <div class="line"></div>
        <!-- 协会介绍 -->
        <div class="aboutCompany">
          <div class="aboutCompany">
            <div class="title">
              <span class="s1">协会介绍</span>
              <!-- <span v-show="guildInfo.guildExplain.length > 100" class="s2" @click="showMore"><span :class="isMore ? 'arrow up' :'arrow down' "></span>{{isMore?'展开':'收起'}}</span> -->
            </div>
            <div class="con heightAuto" v-html="guildInfo.guildExplain"></div>
            <!-- <div :class=" isMore ? 'con heightAuto':'con heightAuto'">{{isMore ? Substring(guildInfo.guildExplain) : guildInfo.guildExplain}}</div> -->
            <p class="paddingBottom"></p>
          </div>
        </div>
        <div class="line"></div>
        <!-- 人物访谈 -->
        <div class="peopleInterview">
          <div class="title">人物访谈</div>
          <div class="peopleCon clearfix">
            <div class="info" v-for="item in characterInterview" @click="toStore()">
              <div class="img"><img :src="item.headImage" alt=""></div>
              <p class="name">{{item.userName}}</p>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <!-- 协会报告 -->
        <div class="reportList">
          <div class="title">协会报告</div>
          <div class="conList">
            <div class="info clearfix" v-for="item in guildReport" @click="toStore()">
              <div class="img"><img :src="item.imageAddr" alt=""></div>
              <div class="txt">
                <p class="p1">{{item.contentTitle}}</p>
                <p class="p2">{{item.publisherName}}</p>
                <p class="p3">{{item.positionName}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-morerepeat :actionId="$route.query.accountId" :shareSwiper="shareSwiper" :isshare="true" :datatype="2"></v-morerepeat>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      isMore:true,//展开
      heightAuto:'heightAuto',
      guildInfo:{},//协会信息
      guildReport:[],//协会报告
      characterInterview:[],//协会人物访谈
      token:"",
      popShow:false,
      shareSwiper:'',
    }
  },
  created(){
    this.init();
  },
  mounted(){
    weixin.shareInfo(2,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(2,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },
    init(){
      this.$http.get("/content/unsecured/app/guild/by/id?guildId="+this.$route.query.contentId)
      .then((response) => {
        this.characterInterview = response.respData.characterInterview;
        this.guildInfo = response.respData.guildInfo;
        this.guildReport = response.respData.guildReport;
      });
    },
    showMore(){
      this.isMore = !this.isMore;
    },
    Substring(value){
      return value.length > 100 ? value.substring(0,100)+'...' : value
    },
  }
}
</script>

<style lang="less" scoped>
.wrapDiv{
  margin-bottom: 150px;
}
.companyInfoWrap{
  .top{
    position: relative;    
    width: 100%;
    height: 220px;
    .img{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        max-width: 100%;
        max-height: 100%;
      }    
    }
  }
  .data{
    background-color: #fff;
    .name{
      padding: 0 30px;
      margin-bottom: 8px;    
      height: 142px;  
      min-height:20px;
      .img{
        float: left;
        width: 200px;
        height: 150px;
        margin-top: -32px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          max-width: 100%;
          max-height: 100%;
        }
      }
      .d1{
        float: left;
        margin-left: 28px;
        .p1{
          font-size: 30px;
          line-height: 42px;
          color:#333440;
          font-weight: bold;
          margin-top: 16px;
        }       
      }    
    }
  }
  .line{
    height: 20px;;
    background: #FBF6F6;
  }
  .aboutCompany{
    .title{
      height: 84px;
      line-height: 84px;
      padding: 0 30px;
      border-bottom: 1px solid #EFEFEF;
      .s1{
        font-size: 28px;
        color: #333440;
        font-weight: bold;
      }
      .s2{
        float: right;
        color: #EF4B4B;
        font-size: 22px;
        .arrow{
          display: inline-block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          border-bottom-color: #EF4B4B;
          margin-right: 12px;
          border-width: 0 10px 10px;                    
        }
        .up{
          transform: rotate(-180deg);
          transition:all 0.5s;
        }
        .down{
          transform: rotate(0deg);        
          transition:all 0.5s;            
        }
      }
    }
    .con{
      width: 100%;
      font-size: 26px;
      line-height: 48px;
      color: #5B5C66;
      padding: 20px 30px 0 30px;
      max-height: 290px;
      overflow: hidden;
    }
    .paddingBottom{
      height: 28px;
    }
    .heightAuto{
      height: auto;
      max-height: none;
      overflow: auto; 
    }
  }
  .peopleInterview{
    .title{
      height: 84px;
      line-height: 84px;
      padding: 0 30px;
      border-bottom: 1px solid #EFEFEF;
      font-size: 28px;
      color: #333440;
      font-weight: bold;     
    }
    .peopleCon{
      padding: 28px 10px 14px 30px;
      .info{
        float: left;
        width: 120px;
        height: 174px;
        margin: 0 22px 22px 0;
        .img{
          width: 120px;
          height: 120px;
          margin-bottom: 16px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }
        .name{
          font-weight: bold;
          font-size: 24px;
          color: #333440;
          text-align: center;
        }
      }
    }
  }
  .reportList{
    .title{
      height: 84px;
      line-height: 84px;
      padding: 0 30px;
      border-bottom: 1px solid #EFEFEF;
      font-size: 28px;
      color: #333440;
      font-weight: bold;     
    }
    .conList{
      .info{
        padding: 28px 30px 30px 30px;
        border-bottom: 1px solid #EFEFEF;
        .img{
          float: left;
          width: 200px;
          height: 150px;
          margin-right: 28px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .txt{
          float: left;
          width: 460px;
          .p1{
            font-weight: bold;
            line-height: 42px;
            font-size: 30px;
            color: #333440;
          }
          .p2{
            line-height: 34px;
            font-size: 24px;
            color: #5B5C66;
            margin: 8px 0 ;
          }
          .p3{
            width: 460px;
            line-height: 34px;
            font-size: 24px;
            color: #A4A4A4;
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
          }
        }
      }
    }
  }

}
</style>
<style lang="less">
  .companyInfoWrap{
    .heightAuto{
      font-size:32px;
      img,video,table{
        max-width: 100%;
      }
    } 
    
  }
</style>




// WEBPACK FOOTER //
// src/share/shareassociationInfo.vue